import { store } from '../../store';
import Rest from '../../webapi/Rest';
import BaseActions from '../../app/_base_actions';
import update from 'immutability-helper';
import AppActions from '../../app/app_actions';
import { Utils, NumberFormatter, domain, i18n, DateFormatter } from 'arm-common';
import { isNullOrUndefined } from 'util';
import { resolve } from 'path';
import { rest } from 'lodash';


const EnumProdottoActions = Object.freeze({

    PRODOTTO_LIST: 'PRODOTTO_LIST',
    PRODOTTO_INITIALIZED: 'PRODOTTO_INITIALIZED',
    PRODOTTO_DETAILS: 'PRODOTTO_DETAILS',
    PRODOTTO_HANDLE_CHANGE: 'PRODOTTO_HANDLE_CHANGE',
    PRODOTTO_UPDATE: 'PRODOTTO_UPDATE',
    COMPAGNIE_LIST: 'COMPAGNIE_LIST',
    PUNTO_VENDITA_LIST: 'PUNTO_VENDITA_LIST',
    PRODOTTO_CMP_HANDLE_CHANGE: 'PRODOTTO_CMP_HANDLE_CHANGE',
    PRODOTTO_SERVIZI_ESTERNI: 'PRODOTTO_SERVIZI_ESTERNI',
    PRODOTTO_SERVIZI_ESTERNI_HANDLE_CHANGE: 'PRODOTTO_SERVIZI_ESTERNI_HANDLE_CHANGE',
    FONDI_LIST_PRODOTTO: 'FONDI_LIST_PRODOTTO',
    LISTA_PRODOTTI_LINEA_LIBERA: 'LISTA_PRODOTTI_LINEA_LIBERA',
    PRODOTTO_VALORE_DEFAULT_DURATA: 'PRODOTTO_VALORE_DEFAULT_DURATA',
    SEGNELATORI_LOAD_LIST: 'SEGNELATORI_LOAD_LIST',
    PRODOTTO_FIRMA_DIGITALE_HANDLE_CHANGE: 'PRODOTTO_FIRMA_DIGITALE_HANDLE_CHANGE',
    PRODOTTO_FIRMA_DIGITALE: 'PRODOTTO_FIRMA_DIGITALE',
    PRODOTTO_DELETE_GARANZIE: 'PRODOTTO_DELETE_GARANZIE'

});

module.exports.EnumProdottoActions = EnumProdottoActions;


class ProdottoActions extends BaseActions {
    constructor() {
        super();
        this.moduleName = "[ProdottoActions] ";
    }
    get Actions() {

        return EnumProdottoActions;
    }

    getListProdotti() {
        return function (dispatch, getState) {
            let psp = getState().prodotto.psp;
            return Rest.post('admin/prodotto/ricercaProdotti', psp, dispatch).then(
                resolve => {
                    dispatch({ type: EnumProdottoActions.PRODOTTO_LIST, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    clearAllDatiProdotto() {
        return dispatch => {

            dispatch({
                type: EnumProdottoActions.PRODOTTO_INITIALIZED,

            });
            return Promise.resolve();
        }
    }
    getProdottoDetails(id) {
        return function (dispatch) {
            return Rest.postForm('admin/prodotto/prodottoDetails', { id: id }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumProdottoActions.PRODOTTO_DETAILS, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }
    inizializzaCreazioneProdotto() {
        return (dispatch, getState) => {
            let listProdOrigin = getState().prodotto.listProdottiOrigine;
            return Rest.post('admin/prodotto/listaGruppiProdotti', dispatch).then(
                resolve => {

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_INITIALIZED,

                    });
                    let defaultStato = "";
                    let defaultModalitaRatino = "";
                    let defaultModalitaProvvPass = "";


                    let statiProdotto = domain("AI_STATO_PRODOTTO");
                    statiProdotto.forEach(
                        function (element, index) {

                            let info = element.info;
                            if (!isNullOrUndefined(info)) {
                                if (!isNullOrUndefined(info.split('DEFAULT: '))) {
                                    let str = info.split('DEFAULT: ')[1].split(';')[0];

                                    // str = str.replace(';', ''); // ??? 

                                    if (str === "SI") {
                                        defaultStato = element.valCampo;
                                    }
                                }
                            }
                        });

                    let modalitaRatino = domain("AI_MODALITA_RATINO");
                    modalitaRatino.forEach(
                        function (element, index) {

                            let info = element.info;
                            if (!isNullOrUndefined(info)) {

                                if (!isNullOrUndefined(info.split('DEFAULT:'))) {
                                    let str = info.split('DEFAULT: ')[1].split(';')[0];

                                    // str = str.replace(';', ''); // ???

                                    if (str === "SI") {
                                        defaultModalitaRatino = element.valCampo;
                                    }
                                }
                            }
                        });
                    let modalitaProvvPassive = domain("AI_MODALITA_PROVV_PASSIVE");
                    modalitaProvvPassive.forEach(
                        function (element, index) {

                            let info = element.info;
                            if (!isNullOrUndefined(info)) {
                                if (!isNullOrUndefined(info.split('DEFAULT:'))) {
                                    let str = info.split('DEFAULT: ')[1].split(';')[0];

                                    // str = str.replace(';', ''); // ???

                                    if (str === "SI") {
                                        defaultModalitaProvvPass = element.valCampo;
                                    }
                                }
                            }
                        });

                    let ordine = 10;
                    listProdOrigin.forEach((prod) => {
                        if (prod.ordine != null && prod.ordine >= ordine) {
                            ordine = prod.ordine + 10;
                        }
                    });


                    let prodotto = {
                        detailsProdotto: {
                            gruppiProdotto: {
                                $set: resolve
                            },
                            modalitaRatino: {
                                $set: defaultModalitaRatino
                            },
                            modalitaCalcoloProvvPassive: {
                                $set: defaultModalitaProvvPass
                            },
                            stato: {
                                $set: defaultStato
                            },
                            ordine: {
                                $set: ordine
                            }
                        },
                        tabSelected: {
                            $set: 'home-tab'
                        }

                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });

                    return resolve;
                });


        }
    }

    handleChange(index, e) {
        return function (dispatch) {
            let object = {};
            if (index === 'inizioValidita' || index === 'fineValidita' || index === "dataFineAdesione" || index === "dataIncasso") {
                if (!isNullOrUndefined(e) && e !== "") {
                    let data = new Date(e);
                    e = data.getTime();
                } else {
                    e = null;
                }
            }
            object[index] = e;
            // if (index === 'fineValidita' && e<) {

            // }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_HANDLE_CHANGE,
                dato: object
            });
            return Promise.resolve();
        }
    }

    salvaProdotto(history, isClone, idProdottoSorgente) {
        return function (dispatch, getState) {
            let prodottoToSave = new Object();
            prodottoToSave = getState().prodotto.detailsProdotto;

            if (prodottoToSave.listaProdottoCmpPojo === undefined ||
                prodottoToSave.listaProdottoCmpPojo === null) {
                prodottoToSave.listaProdottoCmpPojo = [];
            }
            // controliamo il flag coass
            if (!prodottoToSave.coass && !prodottoToSave.flAssicurazioneCongiunta) {

                if (prodottoToSave.listaProdottoCmpPojo.length > 0) {
                    // siamo in Modifica/ Nuova Versione, prodottoCmp e' valorizzato prima (il primo element del array)

                    prodottoToSave.listaProdottoCmpPojo[0].prodottoCmp.idProdotto = prodottoToSave.id;
                    prodottoToSave.listaProdottoCmpPojo[0].prodottoCmp.idCompagnia = prodottoToSave.idCompagnia;
                    prodottoToSave.listaProdottoCmpPojo[0].prodottoCmp.idPuntoVendita = prodottoToSave.idPuntoVendita;
                    prodottoToSave.listaProdottoCmpPojo[0].prodottoCmp.flMandataria = true;
                    prodottoToSave.listaProdottoCmpPojo[0].prodottoCmp.quotaCoass = '100';
                    prodottoToSave.listaProdottoCmpPojo[0].prodottoCmp.flQuotaGestita = true;

                } else {
                    // Creazione, impostiamo i valori e facciamo push del nuovo ProdottoCmp 
                    let prodottoCmp = {
                        prodottoCmp: {
                            idProdotto: prodottoToSave.id,
                            idCompagnia: prodottoToSave.idCompagnia,
                            idPuntoVendita: prodottoToSave.idPuntoVendita,
                            flMandataria: true,
                            quotaCoass: '100',
                            flQuotaGestita: true,

                        }
                    }


                    prodottoToSave.listaProdottoCmpPojo.push(prodottoCmp);
                }

            } else {
                // controllo la percentuale
                if (prodottoToSave.coass) {
                    let quotaTotale = 0;
                    prodottoToSave.listaProdottoCmpPojo.forEach(element => {

                        if (element.prodottoCmp && element.prodottoCmp.quotaCoass && !element.elimina)
                            quotaTotale += parseInt(element.prodottoCmp.quotaCoass);

                    });
                    if (quotaTotale !== 100) {
                        dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTO.LA_QUOTA_TOTALE_DEVE_ESSERE_100', 'La quota totale deve essere 100%')));
                        return;
                    }
                } else {
                    // controllo il flag AssicurazioneCongiunta
                    if (prodottoToSave.flAssicurazioneCongiunta) {
                        prodottoToSave.listaProdottoCmpPojo.forEach(element => {
                            if (element !== null && element !== undefined) {
                                prodottoToSave.listaProdottoCmpPojo[0].prodottoCmp.quotaCoass = '100';
                                prodottoToSave.listaProdottoCmpPojo[0].prodottoCmp.flQuotaGestita = true;
                            }
                        });
                    }
                }
            }
            // let listaProvvigioniAttive = prodottoToSave.listaProvvigioniAttive;
            // listaProvvigioniAttive.forEach((element, index) => {
            //     let tempDate = listaProvvigioniAttive[index].prodottoGaranziaProvvigioni.dataInizio;
            //     let d = new Date(tempDate);
            //     listaProvvigioniAttive[index].prodottoGaranziaProvvigioni.dataInizio = d.getTime();


            // });
            // prodottoToSave.listaProvvigioniAttive = listaProvvigioniAttive;

            let frazionamenti = getState().prodotto.frazionamenti;
            let nuoviFrazionamenti = [];
            if (frazionamenti !== undefined && frazionamenti !== null && frazionamenti.length > 0) {
                frazionamenti.forEach((element, index) => {

                    if (element.checked) {
                        let frazionamento = { frazionamento: element.valCampo, idProdotto: prodottoToSave.id }
                        nuoviFrazionamenti.push(frazionamento)
                    }
                });

                prodottoToSave.listFrazionamenti = nuoviFrazionamenti;
            }


            let pagamenti = getState().prodotto.pagamenti;
            let nuoviPagamenti = [];
            if (pagamenti !== undefined && pagamenti !== null && pagamenti.length > 0) {
                pagamenti.forEach((element, index) => {

                    if (element.checked) {
                        let pagamento = { pagamento: element.valCampo, idProdotto: prodottoToSave.id }
                        nuoviPagamenti.push(pagamento)
                    }
                });

                prodottoToSave.listPagamenti = nuoviPagamenti;
            }

            let operazioni = getState().prodotto.operazioni;
            let nuoviOperazioni = [];
            let listaOperazioniEsistenti = getState().prodotto.detailsProdotto.listProdottoOperazione;
            if (operazioni !== undefined && operazioni !== null && operazioni.length > 0) {
                operazioni.forEach((element, index) => {
                    if (element.checked) {
                        if (listaOperazioniEsistenti !== undefined && listaOperazioniEsistenti !== null && listaOperazioniEsistenti.length > 0) {
                            let flOperazioneAggiunta = false;
                            listaOperazioniEsistenti.forEach((currOperazione, index) => {
                                if (flOperazioneAggiunta === false && currOperazione !== undefined && currOperazione !== null && currOperazione.opeTipoOperazione !== undefined && currOperazione.opeTipoOperazione !== null && currOperazione.opeTipoOperazione === element.valCampo) {
                                    let operazione = { opeTipoOperazione: element.valCampo, idProdotto: prodottoToSave.id, codQuestionario: currOperazione.codQuestionario, codQuestionarioCliente: currOperazione.codQuestionarioCliente, flTipoBanca: currOperazione.flTipoBanca, flTipoCliente: currOperazione.flTipoCliente }
                                    nuoviOperazioni.push(operazione);
                                    flOperazioneAggiunta = true;
                                }
                            });
                            if (flOperazioneAggiunta === false) {
                                let operazione = { opeTipoOperazione: element.valCampo, idProdotto: prodottoToSave.id }
                                nuoviOperazioni.push(operazione);
                            }
                        } else {
                            let operazione = { opeTipoOperazione: element.valCampo, idProdotto: prodottoToSave.id }
                            nuoviOperazioni.push(operazione);
                        }
                    }
                });

                prodottoToSave.listProdottoOperazione = nuoviOperazioni;
            }

            let durataA = getState().prodotto.durataA;
            let nuovoDurata = [];
            if (durataA !== undefined && durataA !== null && durataA.length > 0) {
                durataA.forEach((element, index) => {

                    if (element.checked) {
                        let durata = { durata: element.valCampo, idProdotto: prodottoToSave.id }
                        nuovoDurata.push(durata)
                    }
                });

                prodottoToSave.listDurata = nuovoDurata;
            }

            let listaSconto = getState().prodotto.listaSconto;
            let nuovoSconto = [];
            if (listaSconto !== undefined && listaSconto !== null && listaSconto.length > 0) {
                listaSconto.forEach((element, index) => {

                    if (element.checked) {
                        let sconto = { sconto: element.valCampo, idProdotto: prodottoToSave.id }
                        nuovoSconto.push(sconto)
                    }
                });

                prodottoToSave.listaSconto = nuovoSconto;
            }


            prodottoToSave.listDocumenti = null
            let path = "admin/prodotto/salvaProdotto";

            if (isClone) {
                path = "admin/prodotto/salvaProdottoClone";
                prodottoToSave.id = idProdottoSorgente;
            }

            if (!isNullOrUndefined(prodottoToSave) && !isNullOrUndefined(prodottoToSave.listaProdottoIntermediarioPojo))
                prodottoToSave.listaProdottoIntermediarioPojo.forEach(intermediario => {
                    if (!isNullOrUndefined(intermediario) && intermediario.prodottoIntermediario === null) {
                        intermediario.prodottoIntermediario = {};
                    }
                });

            prodottoToSave.listSinistri = [];

            delete prodottoToSave.gruppiProdotto;
            delete prodottoToSave.listCompagnie;
            delete prodottoToSave.listProdottiOrigine;
            delete prodottoToSave.documentPrint
            return Rest.post(path, prodottoToSave, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumProdottoActions.PRODOTTO_DETAILS, dati: resolve });
                    if (prodottoToSave.id === null || prodottoToSave.id === undefined || isClone) {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.PRODOTTO_INSERITO_CON_SUCCESSO', 'Prodotto inserito con successo')));
                    } else {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.PRODOTTO_MODIFICATO_CON_SUCCESSO', 'Prodotto modificato con successo')));
                    }
                    history.push({ pathname: '/prodotto/details', state: { id: resolve.id } })
                    return resolve;
                },
                function (reject) {
                    dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTO.NON_SI_PUO_INSERIRE_PRODOTTO', 'Non si puo inserire il prodotto')));
                    return reject;
                });
        }
    }

    insertQuota() {
        return function (dispatch, getState) {
            let prodottoToSave = new Object();
            prodottoToSave = getState().prodotto.detailsProdotto;

            if (prodottoToSave.listaProdottoCmpPojo === undefined ||
                prodottoToSave.listaProdottoCmpPojo === null) {
                prodottoToSave.listaProdottoCmpPojo = [];
            }
            if (prodottoToSave.coass) {
                // prodottoToSave.listaProdottoCmpPojo[
                let quotaTotale = parseInt(prodottoToSave.quotaCoass);
                prodottoToSave.listaProdottoCmpPojo.forEach(element => {
                    if (element.prodottoCmp && element.prodottoCmp.quotaCoass && !element.elimina)
                        quotaTotale += parseInt(element.prodottoCmp.quotaCoass);

                });
                if (quotaTotale > 100) {
                    dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTO.QUOTA_NON_PUO_ESSERE_MAGGIORE_DI_100', 'La quota totale non si puo\' essere maggiore di 100%')));
                    return;
                }


                let prodottoCmp = {
                    prodottoCmp: {
                        idProdotto: prodottoToSave.id,
                        idCompagnia: prodottoToSave.idCompagnia,
                        idPuntoVendita: prodottoToSave.idPuntoVendita,
                        flMandataria: false,
                        quotaCoass: prodottoToSave.quotaCoass,

                    }
                }

                prodottoToSave.listaProdottoCmpPojo.push(prodottoCmp);

                prodottoToSave.quotaCoass = 100 - quotaTotale;

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_DETAILS,
                dati: prodottoToSave
            });
        }

    }
    updateItemsPuntoVendita(index, idCompagnia) {
        return dispatch => {

            let listaPuntiVenditaOfCompagnia = [];
            return Rest.postForm('compagnia/listaPuntiVenditaOfCompagnia', { idCompagnia: idCompagnia }, dispatch).then(
                resolve => {
                    let prodotto = {};
                    if (resolve !== null && resolve.length === 1) {
                        prodotto = {
                            detailsProdotto: {
                                listaProdottoCmpPojo: {
                                    [index]: {
                                        prodottoCmp: {
                                            idPuntoVendita: {
                                                $set: resolve[0].id
                                            },
                                            puntiVendita: { $set: resolve }
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        prodotto = {
                            detailsProdotto: {
                                listaProdottoCmpPojo: {
                                    [index]: {
                                        prodottoCmp: {
                                            puntiVendita: { $set: resolve }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }
    deleteProdotto() {
        return function (dispatch, getState) {
            let id = getState().prodotto.detailsProdotto.id;
            return Rest.postForm('admin/prodotto/eliminaProdotto', { id: id }, dispatch).then(
                resolve => {
                    // dispatch({ type: EnumProdottoActions.PRODOTTO_DETAILS, dati: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.PRODOTTO_ELIMINATO_CON_SUCCESSO', 'Prodotto eliminato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }


    updateProdottoGaranzia(name, index, value) {
        return function (dispatch, getState) {

            // let listaProdottoCmpPojo = getState().prodotto.listaProdottoCmpPojo
            // let quotaTotale = parseInt(prodottoToSave.quotaCoass);
            // listaProdottoCmpPojo.forEach(element => {
            //     if (element.prodottoCmp && element.prodottoCmp.quotaCoass)
            //         quotaTotale += parseInt(element.prodottoCmp.quotaCoass);

            // });
            // if (quotaTotale > 100) {
            //     dispatch(AppActions.addNotify('WARNING', 'La quota totale non si puo\' essere maggiore di 100%'));
            //     return;
            // }
            let prodotto = {
                detailsProdotto: {
                    listaProdottoGaranziaPojo: {
                        [index]: {
                            prodottoGaranzia: {
                                [name]: { $set: value }
                            }
                        }
                    }
                }
            }

            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
        }
    }
    updateProdottoCompagnia(name, index, value) {
        return (dispatch, getState) => {

            // let listaProdottoCmpPojo = getState().prodotto.detailsProdotto.listaProdottoCmpPojo;

            let prodotto = {
                detailsProdotto: {
                    listaProdottoCmpPojo: {
                        [index]: {
                            prodottoCmp: {
                                [name]: { $set: value }
                            }
                        }
                    },

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

        }
    }

    inputChangeHandlerIntermediario(index, name, value) {
        return (dispatch, getState) => {

            // let intermediario = getState().prodotto.detailsProdotto.listaProdottoIntermediarioPojo[index];
            // let selezionato = true;

            if (value === null) {

            }
            let prodotto = {
                detailsProdotto: {
                    listaProdottoIntermediarioPojo: {
                        [index]: {
                            prodottoIntermediario: {
                                [name]: { $set: value },

                            },
                            // selezionato:
                            //     { $set: true },
                        }
                    },

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve()

        }
    }

    resetSelected(index, wasSelected) {
        return (dispatch) => {

            let prodotto = {
                detailsProdotto: {
                    listaProdottoIntermediarioPojo: {
                        [index]: {
                            selezionato: { $set: wasSelected },
                        }
                    },

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve()

        }

    }

    inizializzaNuovoProdottoIntermediario(index) {

        return (dispatch, getState) => {

            let intermediario = getState().prodotto.detailsProdotto.listaProdottoIntermediarioPojo[index].intermediario;
            let prodottoDetails = getState().prodotto.detailsProdotto;
            let prodottoIntermediario = {

                idIntermediario: intermediario.id,
                idProdotto: prodottoDetails.id
            }

            let prodotto = {
                detailsProdotto: {
                    listaProdottoIntermediarioPojo: {
                        [index]: {
                            prodottoIntermediario: { $set: prodottoIntermediario },
                        }
                    },

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve()

        }
    }

    getListCompagnie() {
        return dispatch => {
            return Rest.post('compagnia/listaCompagnia', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumProdottoActions.COMPAGNIE_LIST, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }
    getListaPuntiVenditaOfCompagnia(idCompagnia) {
        return (dispatch) => {

            return Rest.postForm('compagnia/listaPuntiVenditaOfCompagnia', { idCompagnia: idCompagnia }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumProdottoActions.PUNTO_VENDITA_LIST, dati: resolve });

                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }
    handleChangeProdottoCmp(index, e) {
        return function (dispatch) {
            let object = {};
            object[index] = e;
            dispatch({
                type: EnumProdottoActions.PRODOTTO_CMP_HANDLE_CHANGE,
                dato: object
            });
        }
    }
    removeSelectedCompagnia(index) {

        return function (dispatch, getState) {

            let listaProdottoCmpPojo = getState().prodotto.detailsProdotto.listaProdottoCmpPojo;

            listaProdottoCmpPojo = update(listaProdottoCmpPojo, {
                $splice: [
                    [index, 1]
                ]
            });

            let quotaCoass = 100;
            listaProdottoCmpPojo.forEach(element => {
                quotaCoass = quotaCoass - parseInt(element.prodottoCmp.quotaCoass)
            });
            let prodotto = {
                detailsProdotto: {
                    listaProdottoCmpPojo: {
                        $set: listaProdottoCmpPojo
                    },
                    quotaCoass: {
                        $set: quotaCoass
                    }
                }
            }


            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
        }
    }
    setFlEliminaCompagnia(index) {
        return function (dispatch, getState) {

            let listaProdottoCmpPojo = getState().prodotto.detailsProdotto.listaProdottoCmpPojo;

            let quotaCoass = 100 + parseInt(listaProdottoCmpPojo[index].prodottoCmp.quotaCoass);
            listaProdottoCmpPojo.forEach(element => {
                if (!element.elimina)
                    quotaCoass = quotaCoass - parseInt(element.prodottoCmp.quotaCoass)
            });
            let prodotto = {
                detailsProdotto: {
                    listaProdottoCmpPojo: {
                        [index]: {
                            elimina: {
                                $set: true
                            }
                        }
                    },
                    quotaCoass: {
                        $set: quotaCoass
                    }
                }
            }

            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
        }
    }

    updateFlMandataria(name, indexListCmp, value) {
        return (dispatch, getState) => {
            let listaProdottoCmpPojo = getState().prodotto.detailsProdotto.listaProdottoCmpPojo;

            listaProdottoCmpPojo.forEach((element, index) => {
                if (value !== null) {
                    let changedValue = true;
                    if (value === "on") {
                        changedValue = true;
                    } else {
                        changedValue = false
                    }
                    if (index === parseInt(indexListCmp)) {

                        dispatch(this.updateProdottoCompagnia(name, index, changedValue));
                    } else {
                        dispatch(this.updateProdottoCompagnia(name, index, false));
                    }
                }
            });

        }
    }
    calcolaQuaotaCoass() {
        return (dispatch, getState) => {

            let quotaCoass = 100;
            let listaProdottoCmpPojo = getState().prodotto.detailsProdotto.listaProdottoCmpPojo;
            listaProdottoCmpPojo.forEach(element => {
                if (element.prodottoCmp && element.prodottoCmp.quotaCoass)
                    quotaCoass = quotaCoass - parseInt(element.prodottoCmp.quotaCoass);

            });
            if (quotaCoass < 0 || quotaCoass > 100) {
                quotaCoass = 0;
            }
            let prodotto = {
                detailsProdotto: {
                    quotaCoass: {
                        $set: quotaCoass
                    }
                }
            };
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

        }
    }

    updateListaProvviggioniAttive(name, index, value) {
        return (dispatch) => {

            if (name === "dataInizio") {
                let data = new Date(value);
                value = data.getTime();
            }

            let prodotto = {
                detailsProdotto: {
                    listaProvvigioniAttive: {
                        [index]: {
                            prodottoGaranziaProvvigioni: {
                                [name]: { $set: value }
                            }
                        }
                    },

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

        }

    }

    inputChangeHandlerProvvigioniFilters(id, value) {
        return function (dispatch) {

            let prodotto = {
                provvigioniFilters: {
                    [id]: { $set: value }
                }
            }


            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
        }
    }

    applicaFiltriSuTuttiProvvigioni() {
        return function (dispatch, getState) {

            let listaProvvigioniAttive = getState().prodotto.detailsProdotto.listaProvvigioniAttive;

            let provvigioniFilters = getState().prodotto.provvigioniFilters;

            listaProvvigioniAttive.forEach((element, index) => {

                if ((provvigioniFilters.garanzie === undefined
                    || provvigioniFilters.garanzie === null
                    || provvigioniFilters.garanzie === "")
                    || parseInt(provvigioniFilters.garanzie) === parseInt(element.garanzia.id)) {

                    listaProvvigioniAttive[index].prodottoGaranziaProvvigioni.percEmissione = provvigioniFilters.percEmissione;
                    listaProvvigioniAttive[index].prodottoGaranziaProvvigioni.percRinnovo = provvigioniFilters.percRinnovo;

                    if (provvigioniFilters.dataInizio !== undefined &&
                        provvigioniFilters.dataInizio !== null &&
                        provvigioniFilters.dataInizio !== "") {
                        listaProvvigioniAttive[index].prodottoGaranziaProvvigioni.dataInizio = new Date(provvigioniFilters.dataInizio).getTime();
                    } else {
                        listaProvvigioniAttive[index].prodottoGaranziaProvvigioni.dataInizio = null;
                    }

                }
            });

            let prodotto = {
                detailsProdotto: {
                    listaProvvigioniAttive: {
                        $set: listaProvvigioniAttive
                    }
                }
            }


            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
        }
    }

    salvaProvAttive() {
        return function (dispatch, getState) {

            let prodottoToSave = getState().prodotto.detailsProdotto
            return Rest.post("admin/prodotto/salvaProvvigioniAttiveProdotto", prodottoToSave, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumProdottoActions.PRODOTTO_DETAILS, dati: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.PROVVIGIONI_MODIFICATI_CON_SUCCESSO', 'Provvigioni modificati con successo')));
                    return resolve;
                },
                function (reject) {
                    dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTO.NON_SI_PUO_MODIFICARE_PROVVIGIONI', 'Non si puo modificare i provvigioni')));
                    return reject;
                });
        }
    }


    changeSelectedTab(idTab) {

        return function (dispatch) {

            let prodotto = {
                tabSelected: {
                    $set: idTab
                }
            }

            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    clearFiltriProvvigioni() {

        return function (dispatch) {

            let prodotto = {
                provvigioniFilters: {
                    $set: {}
                }
            }

            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    //provvigioni passive

    updateListaProvviggioniPassive(name, index, value) {
        return (dispatch) => {

            if (name === "dataInizio") {
                let data = new Date(value);
                value = data.getTime();
            }

            let prodotto = {
                detailsProdotto: {
                    listaProvvigioniPassive: {
                        [index]: {
                            prodottoGaranziaProvvigioni: {
                                [name]: { $set: value }
                            }
                        }
                    },

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

        }

    }

    inputChangeHandlerProvvigioniPassiveFilters(id, value) {

        return function (dispatch) {

            let prodotto = {
                provvigioniPassiveFilters: {
                    [id]: { $set: value }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto,
            });
        }
    }


    applicaFiltriSuTuttiProvvigioniPassive() {
        return function (dispatch, getState) {

            let listaProvvigioniPassive = getState().prodotto.detailsProdotto.listaProvvigioniPassive;

            let provvigioniPassiveFilters = getState().prodotto.provvigioniPassiveFilters;

            listaProvvigioniPassive.forEach((element, index) => {
                if (((provvigioniPassiveFilters.intermediario === undefined ||
                    provvigioniPassiveFilters.intermediario === null ||
                    provvigioniPassiveFilters.intermediario === "") ||
                    parseInt(listaProvvigioniPassive[index].intermediario.id) === parseInt(provvigioniPassiveFilters.intermediario)) &&
                    ((provvigioniPassiveFilters.garanzie === undefined
                        || provvigioniPassiveFilters.garanzie === null
                        || provvigioniPassiveFilters.garanzie === "")
                        || parseInt(provvigioniPassiveFilters.garanzie) === parseInt(element.garanzia.id)))
                {
                    listaProvvigioniPassive[index].prodottoGaranziaProvvigioni.percEmissione = provvigioniPassiveFilters.percEmissione;
                    listaProvvigioniPassive[index].prodottoGaranziaProvvigioni.percRinnovo = provvigioniPassiveFilters.percRinnovo;


                    if (provvigioniPassiveFilters.dataInizio !== undefined &&
                        provvigioniPassiveFilters.dataInizio !== null &&
                        provvigioniPassiveFilters.dataInizio !== "") {
                        listaProvvigioniPassive[index].prodottoGaranziaProvvigioni.dataInizio = new Date(provvigioniPassiveFilters.dataInizio).getTime();
                    } else {
                        listaProvvigioniPassive[index].prodottoGaranziaProvvigioni.dataInizio = null;
                    }
                }
            });

            let prodotto = {
                detailsProdotto: {
                    listaProvvigioniPassive: {
                        $set: listaProvvigioniPassive
                    }
                }
            }


            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
        }
    }


    deleteGaranzieDataDelete(listaGaranzieComboDelete) {
        return function (dispatch, getState) {
            let listaProvvigioniPassive = getState().prodotto.detailsProdotto.listaProvvigioniPassive;
            listaProvvigioniPassive.forEach((element, index) => {
                listaProvvigioniPassive[index].elimina = listaGaranzieComboDelete[index];
            });
            let prodotto = {
                detailsProdotto: {
                    listaProvvigioniPassive: {
                        $set: listaProvvigioniPassive
                    }
                }
            }


            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
        }
    }


    deleteProvviggioniEdit() {
        return function (dispatch, getState) {
            // let IdUser = getState().account.utente.userId;
            let prodottoToSave = getState().prodotto.detailsProdotto

            return Rest.post("admin/prodotto/deleteProvviggioniEdit", prodottoToSave, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.PROVVIGGIONI_PASSIVE_ELIMINATO_CON_SUCCESSO', 'Provviggioni Passive eliminato con successo')));
                    //                 history.push({ pathname: 'admin/prodotto/details', state: { id: prodottoToSave.id } })
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    deleteGaranzieAttiveDataDelete(listaGaranzieComboDelete) {
        return function (dispatch, getState) {
            let listaProvvigioniAttive = getState().prodotto.detailsProdotto.listaProvvigioniAttive;
            listaProvvigioniAttive.forEach((element, index) => {
                listaProvvigioniAttive[index].elimina = listaGaranzieComboDelete[index];
            });
            let prodotto = {
                detailsProdotto: {
                    listaProvvigioniAttive: {
                        $set: listaProvvigioniAttive
                    }
                }
            }


            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
        }
    }


    deleteProvviggioniAttiveEdit() {
        return function (dispatch, getState) {
            // let IdUser = getState().account.utente.userId;
            let prodottoToSave = getState().prodotto.detailsProdotto

            return Rest.post("admin/prodotto/deleteProvviggioniAttiveEdit", prodottoToSave, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DPROVVIGGIONI_ATTIVE_ELIMINATO_CON_SUCCESSO', 'Provviggioni Attive eliminato con successo')));
                    //                 history.push({ pathname: 'admin/prodotto/details', state: { id: prodottoToSave.id } })
                    return resolve;
                }, reject => {
                    return reject;
                });
        }
    }

    salvaProvPassive() {
        return function (dispatch, getState) {

            let prodottoToSave = getState().prodotto.detailsProdotto
            return Rest.post("admin/prodotto/salvaProvvigioniPassiveProdotto", prodottoToSave, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumProdottoActions.PRODOTTO_DETAILS, dati: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.PROVVIGIONI_PASSIVE_MODIFICATI_CON_SUCCESSO', 'Provvigioni passive modificati con successo')));
                    return resolve;
                },
                function (reject) {
                    dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTO.NON_SI_PUO_MODIFICARE_PROVVIGIONI_PASSIVE', 'Non si puo modificare i provvigioni passive')));
                    return reject;
                });
        }
    }


    clearFiltriProvvigioniPassive() {

        return function (dispatch) {

            let prodotto = {
                provvigioniPassiveFilters: {
                    $set: {}
                }
            }

            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    searchProdotto() {

        return function (dispatch, getState) {
            let psp = getState().prodotto.psp;
            // if (psp.dataValidita !== undefined && psp.dataValidita !== null) {


            // }

            return Rest.post('admin/prodotto/ricercaProdotti', psp, dispatch).then(
                resolve => {
                    dispatch({ type: EnumProdottoActions.PRODOTTO_LIST, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    inputChangeHandlerProdottoSearch(id, value) {
        return function (dispatch) {

            if (id === "dataValidita") {
                let data = new Date(value);
                value = data.getTime();
            }
            let prodotto = {
                psp: {
                    [id]: { $set: value }
                }
            }


            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
        }
    }

    inizilizzaNuovaVesioneProdotto() {
        return function (dispatch, getState) {

            let prodottoPadre = getState().prodotto.detailsProdotto;

            let listaProdottoCmpPojo = prodottoPadre.listaProdottoCmpPojo;
            let listaProdottoGaranziaPojo = prodottoPadre.listaProdottoGaranziaPojo;
            let listaProdottoIntermediarioPojo = prodottoPadre.listaProdottoIntermediarioPojo;
            let listaProvvigioniAttive = prodottoPadre.listaProvvigioniAttive;
            let listaProvvigioniPassive = prodottoPadre.listaProvvigioniPassive;
            let listFrazionamenti = prodottoPadre.listFrazionamenti;
            let listPagamenti = prodottoPadre.listPagamenti;
            let listSinistri = prodottoPadre.listSinistri;
            let listProdottoLinea = prodottoPadre.listProdottoLinea;
            let listProdottoOperazione = prodottoPadre.listProdottoOperazione;
            let listProdottoConvenzione = prodottoPadre.listProdottoConvenzione;
            let listDurata = prodottoPadre.listDurata;
            let listaSconto = prodottoPadre.listaSconto;
            // imposto le id a null perche' altrimenti vanno eliminate quelle del prodotto padre  
            listaProdottoCmpPojo.forEach((element, index) => {
                element.prodottoCmp.id = null;
            });
            listaProdottoGaranziaPojo.forEach((element, index) => {
                if (!isNullOrUndefined(element.prodottoGaranzia)) {
                    element.prodottoGaranzia.id = null;
                }
            });
            listaProdottoIntermediarioPojo.forEach((element, index) => {
                if (!isNullOrUndefined(element.prodottoIntermediario)) {
                    element.prodottoIntermediario.id = null;
                }
            });
            listaProvvigioniAttive.forEach((element, index) => {
                if (!isNullOrUndefined(element.prodottoGaranziaProvvigioni)) {
                    element.prodottoGaranziaProvvigioni.id = null;
                    element.prodottoGaranziaProvvigioni.idProdotto = null;
                }
            });
            listaProvvigioniPassive.forEach((element, index) => {
                if (!isNullOrUndefined(element.prodottoGaranziaProvvigioni)) {
                    element.prodottoGaranziaProvvigioni.id = null;
                    element.prodottoGaranziaProvvigioni.idProdotto = null;
                }
            });

            listFrazionamenti.forEach((element, index) => {
                element.idProdottoFrazionamento = null;
                element.idProdotto = null;
            });

            listPagamenti.forEach((element, index) => {
                element.idProdottoPagamento = null;
                element.idProdotto = null;
            });

            listSinistri.forEach((element, index) => {
                element.idProdottoSinistri = null;
                element.idProdotto = null;
            });

            listProdottoLinea.forEach((element, index) => {
                element.idProdottoLinea = null;
                element.idProdotto = null;
            });

            listProdottoOperazione.forEach((element, index) => {
                element.idProdottoOperazione = null;
                element.idProdotto = null;
            });

            listProdottoConvenzione.forEach((element, index) => {
                element.idProdottoConvenzione = null;
                element.idProdotto = null;
            });
            listDurata.forEach((element, index) => {
                element.idProdottoDurata = null;
                element.idProdotto = null;
            });

            listaSconto.forEach((element, index) => {
                element.id = null;
                element.idProdotto = null;
            });

            let prodotto = {
                detailsProdotto: {
                    id: {
                        $set: null
                    },
                    nomeVersione: {
                        $set: null
                    },
                    idOrigine: {
                        $set: prodottoPadre.idOrigine
                    },
                    idPadre: {
                        $set: prodottoPadre.id
                    },
                    listaProdottoCmpPojo: {
                        $set: listaProdottoCmpPojo
                    },
                    inizioValidita: {
                        $set: null
                    },
                    fineValidita: {
                        $set: null
                    },
                    ranking: {
                        $set: prodottoPadre.ranking
                    },
                    codice: {
                        $set: prodottoPadre.codice
                    },
                    listaProdottoGaranziaPojo: {
                        $set: listaProdottoGaranziaPojo
                    },
                    listaProdottoIntermediarioPojo: {
                        $set: listaProdottoIntermediarioPojo
                    },
                    listaProvvigioniAttive: {
                        $set: listaProvvigioniAttive
                    },
                    listaProvvigioniPassive: {
                        $set: listaProvvigioniPassive
                    },
                    prodottoPadre: {
                        $set: prodottoPadre
                    }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            }, { type: EnumProdottoActions.PRODOTTO_DETAILS, dati: prodottoPadre });
            return Promise.resolve();
        }
    }

    inizilizzaCloneProdotto() {
        return function (dispatch, getState) {

            let prodottoPadre = getState().prodotto.detailsProdotto;

            let listaProdottoCmpPojo = prodottoPadre.listaProdottoCmpPojo;
            let listaProdottoGaranziaPojo = prodottoPadre.listaProdottoGaranziaPojo;
            let listaProdottoIntermediarioPojo = prodottoPadre.listaProdottoIntermediarioPojo;
            let listaProvvigioniAttive = prodottoPadre.listaProvvigioniAttive;
            let listaProvvigioniPassive = prodottoPadre.listaProvvigioniPassive;
            let listFrazionamenti = prodottoPadre.listFrazionamenti;
            let listPagamenti = prodottoPadre.listPagamenti;
            let listSinistri = prodottoPadre.listSinistri;
            let listDurata = prodottoPadre.listDurata;
            let listaSconto = prodottoPadre.listaSconto;
            // imposto le id a null perche' altrimenti vanno eliminate quelle del prodotto padre  
            listaProdottoCmpPojo.forEach((element, index) => {
                element.prodottoCmp.id = null;
            });
            listaProdottoGaranziaPojo.forEach((element, index) => {
                if (!isNullOrUndefined(element.prodottoGaranzia)) {
                    element.prodottoGaranzia.id = null;
                }
            });
            listaProdottoIntermediarioPojo.forEach((element, index) => {
                if (!isNullOrUndefined(element.prodottoIntermediario)) {
                    element.prodottoIntermediario.id = null;
                }
            });
            listaProvvigioniAttive.forEach((element, index) => {
                if (!isNullOrUndefined(element.prodottoGaranziaProvvigioni)) {
                    element.prodottoGaranziaProvvigioni.id = null;
                }
            });
            listaProvvigioniPassive.forEach((element, index) => {
                if (!isNullOrUndefined(element.prodottoGaranziaProvvigioni)) {
                    element.prodottoGaranziaProvvigioni.id = null;
                }
            });

            listFrazionamenti.forEach((element, index) => {
                element.idProdottoFrazionamento = null;
                element.idProdotto = null;
            });

            listPagamenti.forEach((element, index) => {
                element.idProdottoPagamento = null;
                element.idProdotto = null;
            });

            listSinistri.forEach((element, index) => {
                element.idProdottoSinistri = null;
                element.idProdotto = null;
            });

            listDurata.forEach((element, index) => {
                element.idProdottoDurata = null;
                element.idProdotto = null;
            });

            listaSconto.forEach((element, index) => {
                element.id = null;
                element.idProdotto = null;
            });

            let prodotto = {
                detailsProdotto: {
                    id: {
                        $set: null
                    },
                    nomeVersione: {
                        $set: null
                    },
                    idOrigine: {
                        $set: null
                    },
                    idPadre: {
                        $set: null
                    },
                    listaProdottoCmpPojo: {
                        $set: listaProdottoCmpPojo
                    },
                    inizioValidita: {
                        $set: null
                    },
                    fineValidita: {
                        $set: null
                    },
                    ranking: {
                        $set: prodottoPadre.ranking
                    },
                    codice: {
                        $set: prodottoPadre.codice
                    },
                    listaProdottoGaranziaPojo: {
                        $set: listaProdottoGaranziaPojo
                    },
                    listaProdottoIntermediarioPojo: {
                        $set: listaProdottoIntermediarioPojo
                    },
                    listaProvvigioniAttive: {
                        $set: listaProvvigioniAttive
                    },
                    listaProvvigioniPassive: {
                        $set: listaProvvigioniPassive
                    },
                    prodottoPadre: {
                        $set: null
                    }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            }, { type: EnumProdottoActions.PRODOTTO_DETAILS, dati: prodottoPadre });
            return Promise.resolve();
        }
    }

    inizilizzaModificaProdotto() {
        return (dispatch, getState) => {
            let prodotto = getState().prodotto.detailsProdotto;
            let listaPuntiVenditaOfCompagnia = []
            if (!isNullOrUndefined(prodotto.listaProdottoCmpPojo) && prodotto.listaProdottoCmpPojo.length > 0) {
                if (prodotto.listaProdottoCmpPojo.length > 1 && prodotto.flAssicurazioneCongiunta === false) {
                    // valorizziamo coass true else false
                    prodotto.coass = true
                } else {
                    // una sola compagnia
                    let prodottoCmp = prodotto.listaProdottoCmpPojo[0].prodottoCmp;
                    prodotto.idCompagnia = prodottoCmp.idCompagnia;
                    prodotto.idPuntoVendita = prodottoCmp.idPuntoVendita;


                }
            } else {
                // nessuna cmp
            }

            if (prodotto.listSinistri === undefined || prodotto.listSinistri === null ||
                prodotto.listSinistri.length === 0) {

                prodotto.listSinistri = [{}];
            }
            // let prodottoReducer = {
            //     detailsProdotto: {
            //         $set: prodotto
            //     },
            //     listaPuntiVenditaOfCompagnia: {
            //         $set: listaPuntiVenditaOfCompagnia
            //     }
            // }

            dispatch({ type: EnumProdottoActions.PRODOTTO_DETAILS, dati: prodotto });

            // dispatch({
            //     type: EnumProdottoActions.PRODOTTO_UPDATE,
            //     prodotto: prodottoReducer
            // });
            return dispatch(this.getListCompagnie());
            // Promise.resolve();
        }
    }

    handleChangeProdottoCmp(id, value) {
        return function (dispatch) {

            let prodotto = {
                detailsProdotto: {
                    prodottoCmp: {
                        [id]: { $set: value }
                    }
                }
            }

            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });



        }
    }

    getListProdottiOrgine() {
        return function (dispatch) {
            let psp = {
                origine: true
            };
            return Rest.post('admin/prodotto/ricercaProdotti', psp, dispatch).then(
                resolve => {

                    let prodotto = {
                        listProdottiOrigine: {
                            $set: resolve
                        }
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    getPrdottoOrgineDetails(id) {
        return function (dispatch) {
            return Rest.postForm('admin/prodotto/prodottoDetails', { id: id }, dispatch).then(
                resolve => {
                    let prodotto = {
                        prodottoOrigine: {
                            $set: resolve
                        }
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }

    inizializzaNuovoProdottoDaMicroCategoria(idMicroCategoria) {

        return dispatch => {
            dispatch(this.getListCompagnie())
            dispatch(this.inizializzaCreazioneProdotto()).then(
                resolve => {
                    let prodotto = {
                        detailsProdotto: {
                            idMicroCategoria: {
                                $set: idMicroCategoria
                            }
                        }
                    }


                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto

                    });


                }
            )




            return Promise.resolve()
        }


    }
    inizializzaMicroCategorieProdotto() {
        return dispatch => {
            return Rest.post('admin/prodotto/listaGruppiProdotti', dispatch).then(
                resolve => {

                    let prodotto = {
                        detailsProdotto: {
                            gruppiProdotto: {
                                $set: resolve
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
            )
        }
    }

    getDocumentiProdotto(idProdotto) {

        return dispatch => {
            return Rest.postForm('admin/prodotto/listaDocumenti', { idProdotto: idProdotto }, dispatch).then(
                resolve => {

                    let prodotto = {
                        detailsProdotto: {
                            listDocumenti: {
                                $set: resolve
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
            )
        }

    }

    uploadFile(formData) {
        console.log(" uploadFile ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            let idProdotto = getState().prodotto.detailsProdotto.id;
            formData.append('idProdotto', idProdotto);
            return Rest.postForm('admin/prodotto/importDocument', formData, dispatch, options)
                .then(resolve => {
                    dispatch(
                        this.getDocumentiProdotto(idProdotto)
                    );
                    dispatch(AppActions.addNotify('SUCCESS', 'Document importato con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }



    // downloadDocument(doc) {


    //     // let blob = new Blob([document.content], { type: 'pdf' });
    //     // let url = URL.createObjectURL(blob);
    //     // window.open(url);
    //     let resolve = doc.content;

    //     let link = document.createElement('a');
    //     link.download = doc.name;
    //     link.href = resolve;
    //     link.target = "_blank";
    //     document.body.appendChild(link);

    //     link.click();

    //     //remove the link when done
    //     document.body.removeChild(link);

    //     return Promise.resolve();
    // };

    downloadDocument(documentId) {
        console.log("[AppActions]  download [documentId] " + documentId);
        return function (dispatch) {
            return Rest.downloadFileStreamGET('admin/prodotto/download?documentId=' + documentId, dispatch).then(
                resolve => {
                    console.log("[AppActions]  download [documentId] " + documentId) + " resolve";
                }, reject => {
                    console.log("[AppActions]  download [documentId] " + documentId) + " reject";
                });
        }
    }

    uploadImage(formData) {
        console.log(" uploadImage ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            return Rest.postForm('admin/prodotto/importImage', formData, dispatch, options)
                .then(resolve => {
                    let prodotto = {
                        detailsProdotto: {
                            imagine: {
                                $set: resolve.imagine
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                    dispatch(AppActions.addNotify('SUCCESS', 'Imagine importata con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }

    inputChangeHandlerDocUpload(id, value) {
        return (dispatch, getState) => {


            let prodotto = {
                documentUpload: {
                    [id]: { $set: value }

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve();


        }
    }

    salvaDocumentUpload() {
        return (dispatch, getState) => {

            let document = getState().prodotto.documentUpload;
            let idProdotto = getState().prodotto.detailsProdotto.id;
            document.idProdotto = idProdotto;
            return Rest.post('admin/prodotto/salvaDocumentUpload', document, dispatch)
                .then(resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', 'Document Upload salvato con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }

    getDocumentiProdottoUpload(idProdotto) {

        return dispatch => {
            return Rest.postForm('admin/prodotto/listaDocumentiUpload', { idProdotto: idProdotto }, dispatch).then(
                resolve => {

                    let prodotto = {
                        detailsProdotto: {
                            listDocumentiUpload: {
                                $set: resolve
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
            )
        }

    }

    inizilizzaNuovoDocUpload(order) {
        return dispatch => {

            let prodotto = {
                documentUpload: {
                    $set: {
                        ordVis: order,
                        checkQrCode: true
                    }

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve();
        }
    }

    inizilizzaModificaDocUpload(doc) {
        return dispatch => {

            let prodotto = {
                documentUpload: {
                    $set: doc

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve();
        }
    }

    inzializzaModificaFrazionamenti() {
        return (dispatch, getState) => {
            let frazionamenti = domain('AI_FRAZIONAMENTO');
            let rows = getState().prodotto.detailsProdotto.listFrazionamenti;
            if (frazionamenti !== undefined && frazionamenti !== null && frazionamenti.length > 0) {

                frazionamenti.forEach((element, index) => {
                    if (rows !== undefined && rows !== null) {
                        let frazionamentoIndex = rows.findIndex(fra => fra.frazionamento === element.valCampo);

                        if (frazionamentoIndex !== -1) {
                            element.checked = true;
                        } else {
                            element.checked = false;
                        }
                    }
                });
            }

            let prodotto = {
                frazionamenti: {
                    $set: frazionamenti

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve();
        }

    }

    inzializzaModificaPagamenti() {
        return (dispatch, getState) => {
            let pagamenti = domain('AI_PAGAMENTO');
            
            let rows = getState().prodotto.detailsProdotto.listPagamenti;

            if (pagamenti != null) {
                pagamenti.forEach((element, index) => {

                    let pagamentoIndex = -1;
                    if (rows !== undefined && rows !== null) {
                        pagamentoIndex = rows.findIndex(fra => fra.pagamento === element.valCampo);

                    }

                    if (pagamentoIndex !== -1) {
                        element.checked = true;
                    } else {
                        element.checked = false;
                    }
                });
            }
            // if (rows !== undefined && rows !== null && rows.length > 0) {

            //     pagamenti.forEach((element, index) => {
            //         let pagamentoIndex = pagamenti.findIndex(fra => fra.valCampo === element.pagamento);

            //         if (pagamentoIndex !== -1) {
            //             pagamenti[pagamentoIndex].checked = true;
            //         }
            //     });
            // }

            let prodotto = {
                pagamenti: {
                    $set: pagamenti

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve();
        }

    }


    deleteProdottoDocument(id) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/prodotto/eliminaProdottoDocument', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO_ELIMINATO_CON_SUCCESSO', 'Documento eliminato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }
    deleteProdottoDocumentUpload(id) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/prodotto/eliminaProdottoDocumentUpload', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO_ELIMINATO_CON_SUCCESSO', 'Documento eliminato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    inputChangeHandlerSinistri(id, value) {
        return function (dispatch, getState) {

            let prodotto = {
                detailsProdotto: {
                    listSinistri: {
                        [0]: {
                            [id]: {
                                $set: value
                            }
                        }
                    }
                }
            }

            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

        }
    }

    getDocumentiProdottoPolizza(idProdotto) {

        return dispatch => {
            return Rest.postForm('admin/prodotto/listaDocumentiPolizza', { idProdotto: idProdotto }, dispatch).then(
                resolve => {

                    let documentType = ['Adesione', 'Appendice', 'Frontespizio', 'Quietanza'];

                    let documentiPolizze = [];

                    documentType.forEach(element => {
                        let docIndex = resolve.findIndex(doc => doc.documentType === element);

                        if (docIndex === -1) {
                            documentiPolizze.push({ documentType: element })
                        } else {
                            documentiPolizze.push(resolve[docIndex]);
                        }

                    });

                    // let listDocumenti = resolve;

                    // listDocumenti.forEach(element => {

                    //     if (element.documentType) {

                    //     }
                    // });

                    let prodotto = {
                        detailsProdotto: {
                            listDocumentiPolizza: {
                                $set: documentiPolizze
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
            )
        }

    }

    uploadDocumentPolizza(formData) {
        console.log(" uploadFile ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            let idProdotto = getState().prodotto.detailsProdotto.id;
            formData.append('idProdotto', idProdotto);
            return Rest.postForm('admin/prodotto/importDocumentPolizza', formData, dispatch, options)
                .then(resolve => {
                    dispatch(
                        this.getDocumentiProdottoPolizza(idProdotto)
                    );
                    dispatch(AppActions.addNotify('SUCCESS', 'Document importato con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }

    deleteDocument(idDocument) {
        return (dispatch, getState) => {
            return Rest.postForm('document/deleteDocument', { documentId: idDocument }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO_ELIMINATO_CON_SUCCESSO', 'Documento eliminato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    aggiornaIntermediari() {
        return (dispatch, getState) => {
            return Rest.post('admin/prodotto/aggiornaIntermediari', null, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.INTERMEDIARI_AGGIORNATI', 'Intermediari aggiornati con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    riInizializzaProdottoObject() {
        return function (dispatch, getState) {

            let prodotto = {
                detailsProdotto: {
                    $set: {}
                }
            }

            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

        }
    }

    creaNuovoLinea() {
        console.log(this.moduleName + "creaNuovoLinea ");
        return function (dispatch, getState) {
            let prodottoLine = getState().prodotto.detailsProdotto.listProdottoLinea;
            let indexNext = prodottoLine.length;

            let ordine = 10;
            prodottoLine.forEach((lin) => {
                if (lin.ordine != null && lin.ordine >= ordine) {
                    ordine = lin.ordine + 10;
                }
            });

            let prodotto = {
                detailsProdotto: {
                    listProdottoLinea: {
                        [indexNext]: {
                            $set: {
                                ordine: ordine,
                                editable: true,
                                listProdottoLineaFondi: []
                            }
                        }
                    }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve()
        }
    }

    handleChangeEditLinea(index, parametro, value) {
        console.log(this.moduleName + "handleChangeEditLinea ");
        return function (dispatch, getState) {
            let prodotto;
            if ((parametro === "linDettaglioSottostanti" && !value) ||
                (parametro === "gestioneSeparata" && value)) {
                prodotto = {
                    detailsProdotto: {
                        listProdottoLinea: {
                            [index]: {
                                [parametro]: {
                                    $set: value
                                },
                                listProdottoLineaFondi: {
                                    $set: []
                                },
                                linMinSottostanti: {
                                    $set: null
                                },
                                linMaxSottostanti: {
                                    $set: null
                                },

                            }
                        }
                    }
                }
            } else {
                prodotto = {
                    detailsProdotto: {
                        listProdottoLinea: {
                            [index]: {
                                [parametro]: {
                                    $set: value
                                }
                            }
                        }
                    }
                }
            }

            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    deleteLinea(id) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/prodotto/eliminaProdottoLinea', { id: id }, dispatch).then(
                resolve => {
                    // dispatch({ type: EnumProdottoActions.PRODOTTO_DETAILS, dati: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.LINEA_ELIMINATO_CON_SUCCESSO', 'Linea eliminata con successo') + " id: " + id));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    getLineProdotto(idProdotto) {

        return dispatch => {
            return Rest.postForm('admin/prodotto/listaProdottoLinea', { idProdotto: idProdotto }, dispatch).then(
                resolve => {

                    let prodotto = {
                        detailsProdotto: {
                            listProdottoLinea: {
                                $set: resolve
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
            )
        }

    }

    salvaLinea(indexLinea) {
        return function (dispatch, getState) {

            let prodotto = getState().prodotto.detailsProdotto;
            let prodottoLine = getState().prodotto.detailsProdotto.listProdottoLinea;
            let linea;
            if (prodottoLine) {
                linea = prodottoLine[indexLinea];
                linea.idProdotto = prodotto.id;
            }

            if (linea.gestioneSeparata) {
                let gestoneSeparataList = [];

                // prodottoLine.find(lin => lin.gestioneSeparata === true);
                prodottoLine.forEach((element, index) => {

                    if (element.gestioneSeparata && (element.idProdottoLinea && element.idProdottoLinea !== linea.idProdottoLinea)) {
                        gestoneSeparataList.push(element);
                    }
                });



                if ((gestoneSeparataList && gestoneSeparataList.length > 0)) {
                    dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTO.LINEA_GESTINE_SEPARATA_GIA_ESISTE', 'Già esiste una linea con gestione separata')));

                    return Promise.reject();
                }
            }

            return Rest.post('admin/prodotto/salvaProdottoLinea', linea, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.LINEA_SALVATA_CON_SUCCESSO', 'Linea salvata con successo') + " id" + resolve.idProdottoLinea));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    manageLineaSottostanti(value, indexLinea) {
        return function (dispatch, getState) {

            let prodottoDetails = getState().prodotto.detailsProdotto;
            let prodottoLine = getState().prodotto.detailsProdotto.listProdottoLinea;
            let linea;
            // if (prodottoLine) {
            //     linea = prodottoLine[indexLinea];
            //     linea.idProdotto = prodotto.id;
            // }
            let listProdottoLineaFondi = [];



            if (value && value !== "") {

                for (let i = 0; i < Number(value); i++) {
                    listProdottoLineaFondi.push({ idProdotto: prodottoDetails.id })
                }

                let prodotto = {
                    detailsProdotto: {
                        listProdottoLinea: {
                            [indexLinea]: {
                                listProdottoLineaFondi: {
                                    $set: listProdottoLineaFondi
                                }
                            }
                        },

                    },
                }

                dispatch({
                    type: EnumProdottoActions.PRODOTTO_UPDATE,
                    prodotto: prodotto
                });
            }
        }

    }

    removeOptionFromList(indexLinea, indexFondo) {
        console.log(this.moduleName + " removeOptionFromList: " + indexLinea);
        return (dispatch, getState) => {
            let prodottoDetails = getState().prodotto.detailsProdotto;
            let prodottoLine = getState().prodotto.detailsProdotto.listProdottoLinea;
            if (prodottoLine[indexLinea]) {
                let listProdottoLineaFondi = prodottoLine[indexLinea].listProdottoLineaFondi;
                let linea = prodottoLine[indexLinea];
                // if (isNullOrUndefined(linea.linMinSottostanti) || linea.linMinSottostanti < listProdottoLineaFondi.length) {
                if (listProdottoLineaFondi) {
                    listProdottoLineaFondi = update(listProdottoLineaFondi, {
                        $splice: [
                            [indexFondo, 1]
                        ]
                    });

                    let prodotto = {
                        detailsProdotto: {
                            listProdottoLinea: {
                                [indexLinea]: {
                                    listProdottoLineaFondi: {
                                        $set: listProdottoLineaFondi
                                    }
                                }
                            },

                        },
                    }
                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
                // }
            }
        }
    }



    addOptionButton(indexLinea) {
        console.log(this.moduleName + " removeOptionFromList: " + indexLinea);
        return (dispatch, getState) => {
            let prodottoDetails = getState().prodotto.detailsProdotto;
            let prodottoLine = getState().prodotto.detailsProdotto.listProdottoLinea;
            let linea = prodottoLine[indexLinea];
            let listProdottoLineaFondi = linea.listProdottoLineaFondi;
            // if (isNullOrUndefined(linea.linMaxSottostanti) || linea.linMaxSottostanti > listProdottoLineaFondi.length) {
            if (prodottoLine[indexLinea]) {
                let indexNext = listProdottoLineaFondi.length;
                let prodotto = {
                    detailsProdotto: {
                        listProdottoLinea: {
                            [indexLinea]: {
                                listProdottoLineaFondi: {
                                    [indexNext]: {
                                        $set: { idProdotto: prodottoDetails.id }
                                    }
                                }
                            }
                        },

                    },
                }
                dispatch({
                    type: EnumProdottoActions.PRODOTTO_UPDATE,
                    prodotto: prodotto
                });
            }
            // }
        }
    }

    inputChangeHandlerFondi(indexLinea, indexFondo, name, value) {

        console.log(this.moduleName + " inputChangeHandlerFondi: " + indexLinea);
        return (dispatch, getState) => {
            let prodottoDetails = getState().prodotto.detailsProdotto;
            let prodottoLine = getState().prodotto.detailsProdotto.listProdottoLinea;
            let linea;

            if (value === "") {
                value = null;
            }
            if (prodottoLine[indexLinea]) {

                let prodotto = {
                    detailsProdotto: {
                        listProdottoLinea: {
                            [indexLinea]: {
                                listProdottoLineaFondi: {
                                    [indexFondo]: {
                                        [name]: {
                                            $set: value
                                        }
                                    }

                                }
                            }
                        },

                    },
                }
                dispatch({
                    type: EnumProdottoActions.PRODOTTO_UPDATE,
                    prodotto: prodotto
                });
            }
            return Promise.resolve();
        }
    }


    inputChangeHandlerFondo(name, value) {

        console.log(this.moduleName + " inputChangeHandlerFondo: ");
        return (dispatch, getState) => {

            if (value === "") {
                value = null;
            }

            let prodotto = {
                fondo: {
                    [name]: {
                        $set: value
                    }

                },
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    inizializzaNuovoFondo() {

        console.log(this.moduleName + " inizializzaNuovoFondo: ");
        return (dispatch, getState) => {

            let prodotto = {
                fondo: {
                    $set: {}

                },
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }


    inizializzaNuovoProdotto() {

        console.log(this.moduleName + " inizializzaNuovoProdotto: ");
        return (dispatch, getState) => {

            let prodotto = {
                fondo: {
                    $set: {}

                },
            }

            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }


    inizializzaModificaFondo(row) {

        console.log(this.moduleName + " inizializzaNuovoFondo: ");
        return (dispatch, getState) => {

            let prodotto = {
                fondo: {
                    $set: row

                },
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    inzializzaModificaOperazioni() {
        return (dispatch, getState) => {
            let operazioni = domain('AI_TIPO_OPERAZIONE');
            let rows = getState().prodotto.detailsProdotto.listProdottoOperazione;


            if (operazioni != null) {
                operazioni.forEach((element, index) => {

                    let operazioneIndex = -1;
                    if (rows !== undefined && rows !== null) {
                        operazioneIndex = rows.findIndex(fra => fra.opeTipoOperazione === element.valCampo);
                    }

                    if (operazioneIndex !== -1) {
                        element.checked = true;
                    } else {
                        element.checked = false;
                    }
                });
            }

            let prodotto = {
                operazioni: {
                    $set: operazioni

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve();
        }

    }





    creaNuovaConvenzione() {
        console.log(this.moduleName + "creaNuovaConvenzione ");
        return function (dispatch, getState) {
            let prodottoConvenzione = getState().prodotto.detailsProdotto.listProdottoConvenzione;

            let indexNext = prodottoConvenzione.length;

            let ordine = 10;
            prodottoConvenzione.forEach((con) => {
                if (con.ordine != null && con.ordine >= ordine) {
                    ordine = con.ordine + 10;

                }
            });

            let prodotto = {
                detailsProdotto: {
                    listProdottoConvenzione: {
                        [indexNext]: {
                            $set: {
                                ordine: ordine,
                                editable: true
                            }
                        }
                    }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }
    salvaConvenzione(indexConvenzione) {
        return function (dispatch, getState) {

            let prodotto = getState().prodotto.detailsProdotto;
            let prodottoConvenzione = getState().prodotto.detailsProdotto.listProdottoConvenzione;
            let convenzione;
            if (prodottoConvenzione) {
                convenzione = prodottoConvenzione[indexConvenzione];
                convenzione.idProdotto = prodotto.id;
            }

            return Rest.post('admin/prodotto/salvaProdottoConvenzione', convenzione, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.CONVENZIONE_SALVATA_CON_SUCCESSO', 'convenzione salvata con successo') + " id" + resolve.idProdottoConvenzione));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }


    getConvenzioneProdotto(idProdotto) {

        return dispatch => {
            return Rest.postForm('admin/prodotto/listaProdottoConvenzione', { idProdotto: idProdotto }, dispatch).then(
                resolve => {

                    let prodotto = {
                        detailsProdotto: {
                            listProdottoConvenzione: {
                                $set: resolve
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
            )
        }

    }

    handleChangeEditConvenzione(index, parametro, value) {
        console.log(this.moduleName + "handleChangeEditConvenzione ");
        return function (dispatch, getState) {


            let prodotto = {
                detailsProdotto: {
                    listProdottoConvenzione: {
                        [index]: {
                            [parametro]: {
                                $set: value

                            }
                        }
                    }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    deleteConvenzione(conId) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/prodotto/eliminaProdConvenzione', { conId: conId }, dispatch).then(
                resolve => {
                    // dispatch({ type: EnumProdottoActions.PRODOTTO_DETAILS, dati: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.CONVENZIONE_ELIMINATA_CON_SUCCESSO', 'Convenzione eliminata con successo') + " id: " + conId));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    salvaSottostante(index) {
        return function (dispatch, getState) {

            let fondo = getState().prodotto.fondo;
            let prodottoDetails = getState().prodotto.detailsProdotto;

            let listProdottoLineaFondi = prodottoDetails.listProdottoLinea[index].listProdottoLineaFondi;

            // listProdottoLineaFondi.push(fondo);

            let indexNextFondo = listProdottoLineaFondi.length

            let prodotto = {
                detailsProdotto: {
                    listProdottoLinea: {
                        [index]: {
                            listProdottoLineaFondi: {
                                [indexNextFondo]: {
                                    $set: fondo
                                }
                            }
                        }
                    }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    getProdottoServiziEsterni(idProdotto) {
        return function (dispatch, getState) {
            return Rest.postForm("admin/prodotto/loadProdottoServiziEsterni", { idProdotto: idProdotto }, dispatch).then(
                resolve => {
                    let ret = {};
                    if (resolve) {
                        ret = resolve;
                    }
                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_SERVIZI_ESTERNI,
                        result: ret
                    })
                }
            )
        }
    }


    handleChangeServiziEsterni(index, e) {
        return function (dispatch) {
            let prodottoServiziEsterni = {};
            prodottoServiziEsterni[index] = e;
            dispatch({
                type: EnumProdottoActions.PRODOTTO_SERVIZI_ESTERNI_HANDLE_CHANGE,
                dato: prodottoServiziEsterni
            });
            return Promise.resolve();
        }
    }


    salvaProdottoServiziEsterni(history) {
        return function (dispatch, getState) {

            let prodottoServiziEsterni = getState().prodotto.prodottoServiziEsterni;
            let prodotto = getState().prodotto.detailsProdotto;

            prodottoServiziEsterni["idProdotto"] = prodotto.id;
            return Rest.post("admin/prodotto/salvaProdottoServiziEsterni", prodottoServiziEsterni, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumProdottoActions.PRODOTTO_SERVIZI_ESTERNI, result: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIESTERNI_MODIFICA', 'Servizio esterno modificato con successo')));
                    history.push({ pathname: '/prodotto/details', state: { id: prodotto.id } })
                    return resolve;
                },
                function (reject) {
                    dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIESTERNI_MODIFICA.NON_SI_PUO_MODIFICARE', 'Non si puo modificare servizio esterno')));
                    return reject;
                });
        }
    }

    getListaFondiOfCompagnia(idCompagnia) {
        console.log(" in fondiAction listaFondiOfCompagnia")
        return function (dispatch) {
            return Rest.postForm('admin/fondo/listaFondiOfCompagnia', { idCompagnia: idCompagnia }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumProdottoActions.FONDI_LIST_PRODOTTO, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });

        }
    }

    deleteProdottoImmagine() {
        return function (dispatch, getState) {

            let prodotto = {
                detailsProdotto: {
                    imagine: {
                        $set: null
                    },
                    imagePath: {
                        $set: null
                    },

                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    importJSON(formData) {
        console.log(" importJSON ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            let idProdotto = getState().prodotto.detailsProdotto.id;
            formData.append('idProdotto', idProdotto);
            return Rest.postForm('admin/prodottoQuotation/importJSON', formData, dispatch, options)
                .then(resolve => {

                    // let prodotto = {
                    //     detailsProdotto:
                    //     {
                    //         premio: {
                    //             $set: resolve
                    //         },

                    //     },
                    // }

                    // dispatch({
                    //     type: EnumProdottoActions.PRODOTTO_UPDATE,
                    //     prodotto: prodotto
                    // });

                    dispatch(AppActions.addNotify('SUCCESS', 'Document importato con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }

    quotazioneJSON(idDocument) {
        console.log(" quotazioneJSON ");
        return (dispatch, getState) => {
            let idProdotto = getState().prodotto.detailsProdotto.id;

            return Rest.postForm('admin/prodottoQuotation/quotationJSON', {
                idProdotto: idProdotto,
                idDocument: idDocument
            }, dispatch)
                .then(resolve => {

                    let prodotto = {
                        detailsProdotto: {
                            premio: {
                                $set: resolve
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });

                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }

    getRulelog(idProdotto) {
        console.log(" getRulelog ");
        return (dispatch, getState) => {

            return Rest.postForm('admin/prodottoQuotation/getRulelog', {
                idProdotto: idProdotto,
            }, dispatch)
                .then(resolve => {

                    let prodotto = {
                        detailsProdotto: {
                            ruleLog: {
                                $set: resolve
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });

                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }

    getDocumentiProdottoQuotazione(idProdotto) {

        return dispatch => {
            return Rest.postForm('document/list', {
                referenceType: 'PRODOTTO_QUOTAZIONE',
                referenceId: idProdotto
            }, dispatch).then(
                resolve => {

                    let prodotto = {
                        detailsProdotto: {
                            listDocumentiQuotazione: {
                                $set: resolve
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });

                    return resolve;
                }
            )
        }

    }

    modificaProdottoDocument(doc) {
        return function (dispatch, getState) {

            return Rest.post('admin/prodotto/modificaOrdVis', doc, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO_MODIFICATO_CON_SUCCESSO', 'Documento modificato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    modificaProdottoOperazione(prodOperazione) {
        return function (dispatch, getState) {
            return Rest.post('admin/prodotto/modificaOperazione', prodOperazione, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.OPERAZIONE_MODIFICATA_CON_SUCCESSO', 'Operazione modificata con successo.')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }


    getListaOperazioni(idProdotto) {
        return dispatch => {
            return Rest.postForm('admin/prodotto/listaProdottoOperazione', { idProdotto: idProdotto }, dispatch).then(
                resolve => {
                    let prodotto = {
                        detailsProdotto: {
                            listProdottoOperazione: {
                                $set: resolve
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
            )
        }

    }


    getListPacchetti(idProdotto) {

        return dispatch => {
            return Rest.postForm('admin/prodotto/listaPacchetti', { idProdotto: idProdotto }, dispatch).then(
                resolve => {
                    let prodotto = {
                        detailsProdotto: {
                            listProdottoPacchetto: {
                                $set: resolve
                            },
                        },
                    }
                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
            )
        }
    }


    insertPacchettoLinea() {
        return function (dispatch, getState) {
            let pacchetto = new Object();
            pacchetto = getState().prodotto.detailsPacchetto;

            if (pacchetto.listProdottoPacchettoLinea === undefined || pacchetto.listProdottoPacchettoLinea === null) {
                pacchetto.listProdottoPacchettoLinea = [];
            }

            let percentuale = 0;
            pacchetto.listProdottoPacchettoLinea.forEach(element => {
                if (element.prodottoPacchettoLinea && element.prodottoPacchettoLinea.percentuale && !element.elimina)
                    percentuale += parseInt(element.prodottoPacchettoLinea.percentuale);
            });
            if (percentuale > 100) {
                dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTO.PACCHETTO.QUOTA_NON_PUO_ESSERE_MAGGIORE_DI_100', 'La percentuale totale non si puo\' essere maggiore di 100%')));
                return;
            }

            let prodottoPacchettoLinea = {
                prodottoPacchettoLinea: {
                    idProdottoPacchetto: pacchetto.id,
                    percentuale: percentuale,
                }
            }

            pacchetto.listProdottoPacchettoLinea.push(prodottoPacchettoLinea);
            dispatch({
                type: EnumProdottoActions.PACCHETTO_DETAILS,
                dati: pacchetto
            },);
        }

    }

    creaNuovoPacchetto() {
        console.log(this.moduleName + "creaNuovoPacchetto ");
        return function (dispatch, getState) {
            let prodottoPacchetto = getState().prodotto.detailsProdotto.listProdottoPacchetto;
            let ordine = 10;
            prodottoPacchetto.forEach((pac) => {
                if (pac.ordine != null && pac.ordine >= ordine) {
                    ordine = pac.ordine + 10;
                }
            });

            let indexNext = prodottoPacchetto.length;

            let prodotto = {
                detailsProdotto: {
                    listProdottoPacchetto: {
                        [indexNext]: {
                            $set: {
                                ordine: ordine,
                                editable: true,
                                listProdottoPacchettoLinea: []
                            }
                        }
                    }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve()
        }
    }

    deletePacchetto(id) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/prodotto/eliminaProdottoPacchetto', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.LINEA_ELIMINATO_CON_SUCCESSO', 'Pacchetto eliminata con successo') + " id: " + id));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    salvaPacchetto(indexLinea) {
        return function (dispatch, getState) {

            let prodotto = getState().prodotto.detailsProdotto;
            let prodottoPacchetto = getState().prodotto.detailsProdotto.listProdottoPacchetto;
            let pacchetto;
            if (prodottoPacchetto) {
                pacchetto = prodottoPacchetto[indexLinea];
                pacchetto.idProdotto = prodotto.id;
            }

            return Rest.post('admin/prodotto/salvaProdottoPacchettoLinea', pacchetto, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.PACCHETTO_SALVATA_CON_SUCCESSO', 'Pacchetto salvato con successo') + " id " + resolve.id));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    handleChangeEditPacchetto(index, parametro, value) {
        console.log(this.moduleName + "handleChangeEditPacchetto ");
        return function (dispatch, getState) {
            let prodotto = {
                detailsProdotto: {
                    listProdottoPacchetto: {
                        [index]: {
                            [parametro]: {
                                $set: value
                            }
                        }
                    }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    inputChangeHandlerLinea(name, value) {

        console.log(this.moduleName + " inputChangeHandlerLinea: ");
        return (dispatch, getState) => {

            if (value === "") {
                value = null;
            }

            let prodotto = {
                linea: {
                    [name]: {
                        $set: value
                    }
                },
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    inizializzaModificaLinea(row) {
        console.log(this.moduleName + " inizializzaModificaLinea: ");
        return (dispatch, getState) => {

            let prodotto = {
                linea: {
                    $set: row
                },
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    salvaPacchettoLinea(index) {
        return function (dispatch, getState) {

            let linea = getState().prodotto.linea;
            let prodottoDetails = getState().prodotto.detailsProdotto;
            let listProdottoPacchettoLinea = prodottoDetails.listProdottoPacchetto[index].listProdottoPacchettoLinea;
            let indexNextLinea = listProdottoPacchettoLinea.length

            let prodotto = {
                detailsProdotto: {
                    listProdottoPacchetto: {
                        [index]: {
                            listProdottoPacchettoLinea: {
                                [indexNextLinea]: {
                                    $set: linea
                                }
                            }
                        }
                    }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    inizializzaNuovoPacchettoLinea() {

        console.log(this.moduleName + " inizializzaNuovoPacchettoLinea: ");
        return (dispatch, getState) => {

            let prodotto = {
                linea: {
                    $set: {}
                },
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    removePacchettoLineaFromList(indexLinea, indexFondo) {
        console.log(this.moduleName + " removePacchettoLineaFromList: " + indexLinea);
        return (dispatch, getState) => {
            let prodottoDetails = getState().prodotto.detailsProdotto;
            let prodottoPacchetto = getState().prodotto.detailsProdotto.listProdottoPacchetto;
            if (prodottoPacchetto[indexLinea]) {
                let listProdottoPacchettoLinea = prodottoPacchetto[indexLinea].listProdottoPacchettoLinea;

                if (listProdottoPacchettoLinea) {
                    listProdottoPacchettoLinea = update(listProdottoPacchettoLinea, {
                        $splice: [
                            [indexFondo, 1]
                        ]
                    });

                    let prodotto = {
                        detailsProdotto: {
                            listProdottoPacchetto: {
                                [indexLinea]: {
                                    listProdottoPacchettoLinea: {
                                        $set: listProdottoPacchettoLinea
                                    }
                                }
                            },

                        },
                    }
                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
                // }
            }
        }
    }

    deletePacchetto(id) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/prodotto/eliminaProdottoPacchetto', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.LINEA_ELIMINATO_CON_SUCCESSO', 'Pacchetto eliminata con successo') + " id: " + id));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    uploadFileLinea(formData) {
        console.log(" uploadFileLinea ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            let idProdotto = getState().prodotto.detailsProdotto.id;
            formData.append('idProdotto', idProdotto);
            return Rest.postForm('admin/prodotto/importDocumentLinea', formData, dispatch, options)
                .then(resolve => {
                    dispatch(
                        this.getDocumentiProdotto(idProdotto)
                    );
                    dispatch(AppActions.addNotify('SUCCESS', 'Document importato con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }
    uploadFileFondi(formData) {
        console.log(" uploadFileFondi ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            let idProdotto = formData.get("idProdotto");
            return Rest.postForm('admin/prodotto/importDocumentLinea', formData, dispatch, options)
                .then(resolve => {
                    dispatch(
                        this.getDocumentiProdotto(idProdotto)
                    );
                    dispatch(AppActions.addNotify('SUCCESS', 'Document importato con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }


    deleteProdottoLineaDocument(id) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/prodotto/eliminaLineaDocument', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO_ELIMINATO_CON_SUCCESSO', 'Documento eliminato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    deleteProdottoLineaFondoDocument(id) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/prodotto/eliminaLineaDocumentFondo', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO_ELIMINATO_CON_SUCCESSO', 'Documento eliminato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    salvaPacchettoLineaModifica(index) {
        return function (dispatch, getState) {

            let linea = getState().prodotto.linea;
            let prodottoDetails = getState().prodotto.detailsProdotto;
            let listProdottoPacchettoLinea = prodottoDetails.listProdottoPacchetto[index].listProdottoPacchettoLinea;
            let indexNextLinea = listProdottoPacchettoLinea.findIndex(lin => lin.idLinea == linea.idLinea);


            let prodotto = {
                detailsProdotto: {
                    listProdottoPacchetto: {
                        [index]: {
                            listProdottoPacchettoLinea: {
                                [indexNextLinea]: {
                                    $set: linea
                                }
                            }
                        }
                    }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    publiccaProdotto() {
        return function (dispatch, getState) {
            let id = getState().prodotto.detailsProdotto.id;
            return Rest.postForm('admin/prodotto/pubblica', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.PRODOTTO_PUBBLICATO_CON_SUCCESSO', 'Prodotto pubblicato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    getAiPrintDocumenti() {
        return dispatch => {
            return Rest.post('admin/prodotto/listaAllDocumentiPrint', null, dispatch).then(
                resolve => {
                    let prodotto = {
                        listAiPrintDocumenti: {
                            $set: resolve
                        },
                    }
                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
            )
        }
    }

    deleteProdottoDocumentPrint(id) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/prodotto/eliminaProdottoDocumentPrint', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO_ELIMINATO_CON_SUCCESSO', 'Documento eliminato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    salvaDocumentPrint() {
        return (dispatch, getState) => {

            let document = getState().prodotto.documentPrint;
            let idProdotto = getState().prodotto.detailsProdotto.id;
            document.idProdotto = idProdotto;
            return Rest.post('admin/prodotto/salvaDocumentPrint', document, dispatch)
                .then(resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', 'Document Print salvato con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }

    getDocumentiProdottoPrint(idProdotto) {

        return dispatch => {
            return Rest.postForm('admin/prodotto/listaDocumentiPrint', { idProdotto: idProdotto }, dispatch).then(
                resolve => {

                    let prodotto = {
                        detailsProdotto: {
                            listDocumentiPrint: {
                                $set: resolve
                            },

                        },
                    }

                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_UPDATE,
                        prodotto: prodotto
                    });
                }
            )
        }

    }

    inizilizzaNuovoDocPrint(order) {
        return dispatch => {

            let prodotto = {
                documentPrint: {
                    $set: { ordVis: order }

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve();
        }
    }

    inizilizzaModificaDocPrint(doc) {
        return dispatch => {

            let prodotto = {
                documentPrint: {
                    $set: doc

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve();
        }
    }

    inputChangeHandlerDocPrint(id, value) {
        return (dispatch, getState) => {

            let prodotto = {
                documentPrint: {
                    [id]: { $set: value }
                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve();
        }
    }

    downloadDocumentPrint(id) {
        console.log(this.moduleName + "  scaricaDocument [id] " + id);
        let path = "admin/prodotto/downloadDocumentPrint/" + id;
        return function (dispatch) {
            return Rest.downloadFileStreamPOST(path, dispatch).then(
                resolve => {
                    console.log(" download [path] " + path) + " resolve";
                }, reject => {
                    console.log(" download [path] " + path) + " reject";
                });
        }
    }
    exportProduct() {
        return (dispatch, getState) => {
            let idProdotto = getState().prodotto.detailsProdotto.id;

            return Rest.downloadFileStreamPOST('admin/product/prodotto/exportProduct', { idProdotto: idProdotto }, dispatch).then(
                resolve => {
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }

    importProdottoJSON(formData) {
        let that = this;
        console.log(" importProdottoJSON ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            return Rest.postForm('admin/product/prodotto/importProduct', formData, dispatch, options)
                .then(
                    resolve => {
                        dispatch(AppActions.addNotify('SUCCESS', 'Prodotto importato con successo'));
                        return resolve;
                    },
                    reject => {
                        return reject;
                    }
                );
        }
    }

    importVersioneProdottoJSON(formData) {
        let that = this;
        console.log(" importProdottoJSON ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            return Rest.postForm('admin/product/prodotto/importProductVersione', formData, dispatch, options)
                .then(
                    resolve => {
                        dispatch(AppActions.addNotify('SUCCESS', 'Prodotto importato con successo'));
                        return resolve;
                    },
                    reject => {
                        return reject;
                    }
                );
        }
    }

    deleteProdottoPacchettoDocument(id) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/prodotto/eliminaPacchettoDocument', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO_ELIMINATO_CON_SUCCESSO', 'Documento eliminato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    uploadFilePacchetto(formData) {
        console.log(" uploadFileLinea ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            let idProdotto = getState().prodotto.detailsProdotto.id;
            // let idProdottoPacchetto = formData.get('id');
            formData.append('idProdotto', idProdotto);
            return Rest.postForm('admin/prodotto/uploadFilePacchetto', formData, dispatch, options)
                .then(resolve => {
                    dispatch(
                        this.getDocumentiProdotto(idProdotto)
                    );
                    dispatch(AppActions.addNotify('SUCCESS', 'Document importato con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }




    setOrdineVisibilitaOperazioni(row) {
        return (dispatch, getState) => {
            let rows = getState().prodotto.detailsProdotto.listProdottoOperazione;
            let ordine = 10;


            let indexNext = rows.findIndex(el => el.idProdottoOperazione == row.idProdottoOperazione);
            if (rows !== undefined && rows !== null) {
                rows.forEach((opz) => {
                    if (opz.ordine != null && opz.idProdottoOperazione != row.idProdottoOperazione && opz.ordine >= ordine) {
                        ordine = opz.ordine + 10;

                    }
                });

            }

            let prodotto = {
                detailsProdotto: {
                    listProdottoOperazione: {
                        [indexNext]: {
                            $set: {
                                ordine: ordine
                            }
                        }
                    }
                }
            }

            return ordine;

        }

    }

    eliminaProdottoFondi(idProdottoLineaFondo) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/prodotto/eliminaProdottoFondi', { idProdottoLineaFondo: idProdottoLineaFondo }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.COMPAGNIA.CMP_ELIMINATA_CON_SUCCESSO', 'Prodotto legata con questo fondo eliminata con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }


    getListProdottoLineaLibera() {
        return function (dispatch) {
            return Rest.post('admin/prodotto/listaProdottiLineaLibera', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumProdottoActions.LISTA_PRODOTTI_LINEA_LIBERA, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }


    inputChangeHandlerProdotti(name, value) {
        console.log(this.moduleName + " inputChangeHandlerProdotti: ");
        return (dispatch, getState) => {

            if (value === "") {
                value = null;
            }

            let prodotto = {
                fondo: {
                    [name]: {
                        $set: value
                    }

                },
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    salvaSottostanteFondoModifica(index) {
        return function (dispatch, getState) {

            let fondo = getState().prodotto.fondo;
            let prodottoDetails = getState().prodotto.detailsProdotto;
            let listProdottoLineaFondi = prodottoDetails.listProdottoLinea[index].listProdottoLineaFondi;
            let indexNextFondo = listProdottoLineaFondi.length;

            let prodotto = {
                detailsProdotto: {
                    listProdottoLinea: {
                        [index]: {
                            listProdottoLineaFondi: {
                                [indexNextFondo]: {
                                    $set: fondo
                                }
                            }
                        }
                    }
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    inzializzaModificaDurata() {
        return (dispatch, getState) => {
            let durataA = domain("AI_DURATA");
            let rows = getState().prodotto.detailsProdotto.listDurata;
            if (durataA !== undefined && durataA !== null && durataA.length > 0) {

                durataA.forEach((element, index) => {
                    if (rows !== undefined && rows !== null) {
                        let durataIndex = rows.findIndex(dur => dur.durata === element.valCampo);

                        if (durataIndex !== -1) {
                            element.checked = true;
                        } else {
                            element.checked = false;
                        }
                    }
                });
            }

            let prodotto = {
                durataA: {
                    $set: durataA

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve();
        }

    }

    inzializzaModificaSconto() {
        return (dispatch, getState) => {
            let listaScontoDomain = domain("AI_SCONTO");
            let rows = getState().prodotto.detailsProdotto.listaSconto;
            if (listaScontoDomain !== undefined && listaScontoDomain !== null && listaScontoDomain.length > 0) {

                listaScontoDomain.forEach((element, index) => {
                    if (rows !== undefined && rows !== null) {
                        let scontoIndex = rows.findIndex(dur => dur.sconto === element.valCampo);
                        if (scontoIndex !== -1) {
                            element.checked = true;
                        } else {
                            element.checked = false;
                        }
                    }
                });
            }

            let prodotto = {
                listaSconto: {
                    $set: listaScontoDomain
                },
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

            return Promise.resolve();
        }

    }

    salvaValoreDefaultDurata(idProdottoDurata, id) {
        return (dispatch, getState) => {
            let that = this;
            let prodotto = getState().prodotto.detailsProdotto;
            return Rest.postForm('admin/prodotto/salvaValoreDefaultDurata', { idProdottoDurata: idProdottoDurata, id: id }, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumProdottoActions.PRODOTTO_VALORE_DEFAULT_DURATA, valoreDefaultDurata: resolve })
                    dispatch(that.getProdottoDetails(prodotto.id));
                    dispatch({ type: EnumProdottoActions.PRODOTTO_UPDATE, prodotto: prodotto });
                    return resolve;
                },
                function (reject) {
                    dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIESTERNI_MODIFICA.NON_SI_PUO_MODIFICARE', 'Non si puo salvare valore Default dell Durata')));
                    return reject;
                }
            )
        }
    }

    uploadDocumentTipoExcel(formData) {
        console.log(" uploadDocumentTipoExcel ");
        let options = {};
        return (dispatch, getState) => {
            options.contentType = false;
            options.processData = false;
            options.async = false;
            // let idProdotto = getState().prodotto.detailsProdotto.id;
            // formData.append('idProdotto', idProdotto);
            return Rest.postForm('admin/prodotto/importDocumentTipoExcel', formData, dispatch, options)
                .then(resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', 'Documento tipo excel importata con successo'));
                    return resolve;
                },
                    reject => {
                        dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.DOCUMENT.UPLOAD.TIPO.EXCEL', 'Il File deve essere un excel. stensioni ammesse [.xlsx] invece è di tipo application/pdf')));
                        return reject;
                    }

                )

        }
    }
    deleteProdottoDocumentTipoExcel() {
        return function (dispatch, getState) {

            let prodotto = {
                detailsProdotto: {
                    docTariffa: {
                        $set: null
                    },
                }
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }

    insertAssicurazioneCongiunta() {
        return function (dispatch, getState) {
            let prodottoToSave = new Object();
            prodottoToSave = getState().prodotto.detailsProdotto;

            if (prodottoToSave.listaProdottoCmpPojo === undefined ||
                prodottoToSave.listaProdottoCmpPojo === null) {
                prodottoToSave.listaProdottoCmpPojo = [];
            }
            if (prodottoToSave.flAssicurazioneCongiunta === true) {

                let prodottoCmp = {
                    prodottoCmp: {
                        idProdotto: prodottoToSave.id,
                        idCompagnia: prodottoToSave.idCompagnia,
                        idPuntoVendita: prodottoToSave.idPuntoVendita,
                        quotaCoass: "",

                    }
                }

                prodottoToSave.listaProdottoCmpPojo.push(prodottoCmp);
            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_DETAILS,
                dati: prodottoToSave
            });
        }

    }

    updateProdottoCmpNumeroPolizza(name, index, value) {
        return (dispatch, getState) => {

            // let listaProdottoCmpPojo = getState().prodotto.detailsProdotto.listaProdottoCmpPojo;

            let prodotto = {
                detailsProdotto: {
                    listaProdottoCmpPojo: {
                        [index]: {
                            prodottoCmp: {
                                [name]: { $set: value }
                            }
                        }
                    },

                },

            }
            dispatch({
                type: EnumProdottoActions.PRODOTTO_UPDATE,
                prodotto: prodotto
            });

        }
    }

    getListaSegnelatori() {
        return function (dispatch) {
            return Rest.post('admin/prodotto/listaSegnelatori', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumProdottoActions.SEGNELATORI_LOAD_LIST, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    handleChangeFirmaDigitale(index, e) {
        return function (dispatch) {
            let prodottoFirmaDigitale = {};
            prodottoFirmaDigitale[index] = e;
            dispatch({
                type: EnumProdottoActions.PRODOTTO_FIRMA_DIGITALE_HANDLE_CHANGE,
                dato: prodottoFirmaDigitale
            });
            return Promise.resolve();
        }
    }



    salvaProdottoFirmaDigitale(history) {
        return function (dispatch, getState) {

            let prodottoFirmaDigitale = getState().prodotto.prodottoFirmaDigitale;
            let prodotto = getState().prodotto.detailsProdotto;

            prodottoFirmaDigitale["idProdotto"] = prodotto.id;
            return Rest.post("admin/prodotto/salvaCampiFirmaDigitale", prodottoFirmaDigitale, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumProdottoActions.PRODOTTO_FIRMA_DIGITALE, result: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FIRMA_DIGITALE_MODIFICA', 'Firma Digitale modificato con successo')));
                    history.push({ pathname: '/prodotto/details', state: { id: prodotto.id } })
                    return resolve;
                },
                function (reject) {
                    dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.FIRMA_DIGITALE_MODIFICA.NON_SI_PUO_MODIFICARE', 'Non si puo modificare firma digitale')));
                    return reject;
                });
        }
    }


    getProdottoFirmaDigitale(idProdotto) {
        return function (dispatch, getState) {
            return Rest.postForm("admin/prodotto/loadProdottoFirmaDigitale", { idProdotto: idProdotto }, dispatch).then(
                resolve => {
                    let ret = {};
                    if (resolve) {
                        ret = resolve;
                    }
                    dispatch({
                        type: EnumProdottoActions.PRODOTTO_FIRMA_DIGITALE,
                        result: ret
                    })
                }
            )
        }
    }

};

export default ProdottoActions = new ProdottoActions;